export default policyLink => ({
  en: {
    privacyPolicy: 'Privacy Policy',
    accessibilityStatement: 'Accessibility Statement',
    agree: 'I Agree',
    decline: 'I Decline',
    message: `
                        Your privacy is very important to us.
                        In order to provide our services,
                        we will collect personal data from you directly,
                        as well as that sent via your browser.
                        to learn how we protect your data,
                        refer to our
                        <a href="${policyLink}" target="_blank">privacy policy</a>.
                        `,
  },

  he: {
    privacyPolicy: 'מדיניות פרטיות',
    accessibilityStatement: 'הצהרת נגישות',
    agree: 'אני מאשר',
    decline: 'אני לא מאשר',
    message: `
                        הפרטיות שלך מאוד חשובה לנו
                        על מנת שנוכל לספק לך את שירותנו,
                        אנו אוספים ממך ישירות מידע אישי
                        ומידע שהדפדפן שלך שולח לנו.
                        על מנת ללמוד כיצד אנו שומרים על המידע שלך,
                        קרא/י את
                        <a href="${policyLink}" target="_blank">מדיניות הפרטיות</a>
                        שלנו.
                        `,
  },

  fr: {
    privacyPolicy: 'Politique de confidentialité',
    accessibilityStatement: 'Déclaration d’accessibilité',
    agree: "Je suis d'accord",
    decline: "Je ne suis pas d'accord",
    message: `
                         Votre vie privée est très importante pour nous.
                         Afin de fournir nos services,
                         nous collecterons vos données personnelles directement,
                         ainsi que celui envoyé via votre navigateur.
                         pour apprendre comment nous protégeons vos données,
                         se référer à notre politique de confidentialité
                         <a href="${policyLink}" target="_blank">politique de confidentialité</a>.
                        `,
  },

  de: {
    privacyPolicy: 'Datenschutzrichtlinie',
    agree: 'Ich stimme zu',
    decline: 'Ich stimme nicht zu',
    message: `
                         Ihre Privatsphäre ist uns sehr wichtig.
                         Um unsere Dienstleistungen zu erbringen,
                         Wir sammeln persönliche Daten von Ihnen direkt,
                         sowie die über Ihren Browser gesendet.
                         um zu erfahren, wie wir Ihre Daten schützen,
                         Beachten Sie unsere
                        <a href="${policyLink}" target="_blank">Datenschutzerklärung</a>.
                        `,
  },
});
